import dateFormat from 'dateformat';
import moment from 'moment';

type DateProp = number | string | Date | undefined | null;

export function formatDate(date: DateProp): string {
    const d = getDate(date, 'YYYY-MM-DD HH:mm:Z');
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
    }; //  for formatting the date string output
    return d.toLocaleDateString('sv-SV', options);
}

export function getDate(date?: DateProp, format = ''): Date {
    if (!date || date === '') {
        return moment().toDate();
    } else {
        const newDate = moment(date, format).toDate();
        return newDate;
    }
}

export function toJSONDate(date: DateProp): string {
    if (!date) {
        return '';
    } else {
        const formattedDate = getDate(date);
        const dateString = formattedDate.toISOString();
        return dateString;
    }
}

export function toHTMLDate(date: DateProp): string {
    if (!date) {
        return '';
    } else {
        const formattedDate = getDate(date);
        const dateString = dateFormat(formattedDate, "yyyy-mm-dd'T'HH:MM");
        return dateString;
    }
}

export function toHTMLDateWithoutTime(date: DateProp): string {
    if (!date) {
        return '';
    } else {
        const formattedDate = getDate(date);
        const dateString = dateFormat(formattedDate, 'yyyy-mm-dd');
        return dateString;
    }
}

export function compareDates(a: DateProp, b: DateProp): number {
    if (!a && !b) return 0;
    if (!a) return -1;
    if (!b) return 1;
    return (
        getDate(a, 'YYYY-MM-DD HH:mm:Z').getTime() -
        getDate(b, 'YYYY-MM-DD HH:mm:Z').getTime()
    );
}

export function isDateInBetween(
    date: string | Date,
    startDate: string | Date,
    endDate: string | Date,
): boolean {
    return moment(date).isBetween(moment(startDate), moment(endDate));
}

export function isTodayBetweenDates(
    startDate: string | Date,
    endDate: string | Date,
): boolean {
    return isDateInBetween(new Date(), startDate, endDate);
}

/**
 * Converts an ISO date string to the local time value expected by
 * <input type="datetime-local"> (YYYY-MM-DDTHH:mm).
 */
export function toLocalDateTimeInput(value: string): string {
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return '';
    const timezoneOffsetMs = date.getTimezoneOffset() * 60 * 1000;
    return new Date(date.getTime() - timezoneOffsetMs)
        .toISOString()
        .slice(0, 16);
}

/**
 * Converts a <input type="datetime-local"> value (interpreted as local
 * time) to an ISO 8601 string.
 */
export function toIsoString(localDateTime: string): string {
    return new Date(localDateTime).toISOString();
}
